<template>
  <div v-if="!firstPageInit">
    <div class="row menubar tabs">
      <button @click="$store.state.currentView='Intakes'">Onboarding</button>
      <button class="active">Her-intakes</button>
      <button @click="$store.state.currentView='IntakesCompleted'">Afgeronde intakes</button>
      <button @click="$store.state.currentView='IntakesDeleted'">Geannuleerde intakes</button>
    </div>
    <div
      class="row menubar"
      style="border-top-right-radius: 6px;display: flex;justify-content: space-between"
    >
      <button
        class="dropdown-button"
        @click="toggleFilters"
        :title="`Filters ${filters ? 'verbergen' : 'tonen'}`"
      >
        <awesomeIcon icon="filter"/>
      </button>
      <input
        type="text"
        v-model.lazy="search"
        placeholder="Zoeken"
        title="Zoeken op port, intake, gebruiker, e-mail, telefoonnummer"
        v-show="!filters"
        style="flex:1;border-radius:0"
        @keyup.enter="clearInputs('generalSearch')"
      />
      <button
        class="search-button"
        @click="clearInputs('generalSearch')"
        v-show="!filters"
      >
        <awesomeIcon icon="search" style="padding-bottom:1px;"/>
      </button>
      <button v-if="false" @click="completeIntakes">Complete all intakes</button>
      <inputDropdown
        :array="advisors"
        v-model="currentAdvisor"
        :cb="generalDropdownCB"
        :clearable="true"
        clearedDisplayValue="Adviseur"
        :scroll="true"
        :defaultIndex="-1"
      />
      <div class="dropdown nowrap multi-dropdown" style="float:right">
        <button class="dropdown-button" @click="brandDropdown = true">
          <awesomeIcon icon="sort" />
          Merk{{ selectedBrands.length > 1 ? 'en' : '' }} ({{ selectedBrands.length }})
        </button>
        <div
          class="dropdown-bg"
          v-if="brandDropdown"
          @click="
            brandDropdown = false;
            getIntakes(true);
          "
        />
        <ul class="dropdown-list" v-if="brandDropdown">
          <li
            class="dropdown-deselect"
            @click="selectedBrands = ['Alle merken']"
          >
            <span :class="selectedBrands.length ? '' : 'grey'">
              Alle ({{ selectedBrands.length }}) actieve verwijderen
            </span>
          </li>
          <li
            v-for="(brand, index) in intakeBrands"
            :key="index"
            @click="toggleBrand(brand)"
            :title="(selectedBrands.includes(brand))
                ? 'Verwijderen'
                : 'Toevoegen'
              "
          >
          <div class="dropdown-checkbox checkbox-green">
            <awesomeIcon :icon="selectedBrands.includes(brand)
                ? 'check-square'
                : 'fa-regular fa-square'
              "/>
          </div>
          <span :class="selectedBrands.includes(brand) ? 'checkbox-green' : ''">
            {{ brand }}
          </span>
          </li>
        </ul>
      </div>
      <inputDropdown
        :array="orders"
        v-model="order"
        :cb="generalDropdownCB"
      />
      <inputDropdown
        :array="groups"
        v-model="view"
        :cb="generalDropdownCB"
        align="right"
      />
    </div>

    <div class="filters menubar" ref="filters" :class="filters ? 'active' : ''">
      <div class="filters-inner">
        <div class="triple-filter">
          <div class="triple-name">Voorrang</div>
          <div class="triple-filter-holder">
            <div
              v-for="(name) in priorityTriple"
              :key="name"
              @click="priority = name;getIntakes(true)"
              :class="priority === name ? 'active' : ''"
            >
              {{ name }}
            </div>
          </div>
        </div>
        <div class="triple-filter">
          <div class="triple-name">Aangemaakt door</div>
          <div class="triple-filter-holder">
            <div
              v-for="(name) in creatorTriple"
              :key="name"
              @click="creator = name;getIntakes(true)"
              :class="creator === name ? 'active' : ''"
            >
              {{ name }}
            </div>
          </div>
        </div>
        <div class="triple-filter">
          <div class="triple-name">Verstuurd door</div>
          <div class="triple-filter-holder">
            <div
              v-for="(name) in senderTriple"
              :key="name"
              @click="sender = name;getIntakes(true)"
              :class="sender === name ? 'active' : ''"
            >
              {{ name }}
            </div>
          </div>
        </div>
        <div class="input">
          <span>ID</span>
          <input type="number" v-model.lazy="idInput" @keyup.enter="getIntakes(true)"/>
        </div>
        <div class="input">
          <span>Portefeuille ID</span>
          <input type="text" v-model.lazy="portInput" @keyup.enter="getIntakes(true)"/>
        </div>
        <div class="input">
          <span>Inleg (€)</span>
          <input type="number" v-model.lazy="investmentInput" @keyup.enter="getIntakes(true)"/>
        </div>
        <div class="input">
          <span>Voortgang (%)</span>
          <input type="text" v-model.lazy="progressInput" @keyup.enter="getIntakes(true)"/>
        </div>
        <div class="input">
          <span>Telefoonnummer</span>
          <input type="text" v-model.lazy="phoneInput" @keyup.enter="getIntakes(true)"/>
        </div>
        <div class="input">
          <span>Sinds</span>
          <input type="date" v-model.lazy="sinceInput" @keyup.enter="getIntakes(true)"/>
        </div>
        <div class="input">
          <span>Beheerder</span>
          <inputSuggest
            type="text"
            class="userIdInput"
            width="190px"
            v-model="managerInput"
            :cb="getIntakes"
            ref="managerInput"
            :roles="[7, 8, 9, 10]"
          />
        </div>
        <div class="input">
          <span>Gebruiker</span>
          <inputSuggest
            type="text"
            class="userIdInput"
            width="190px"
            v-model="userInput"
            :cb="getIntakes"
            ref="userInput"
          />
        </div>
        <div class="input buttons">
          <button @click="clearInputs()">
            Wissen
          </button>
          <button @click="getIntakes()">
            <awesomeIcon icon="sync"/>
          </button>
          <button @click="search = '';getIntakes(true)">
            <awesomeIcon icon="search"/>
          </button>
        </div>
      </div>
    </div>

    <div class="card" v-if="intakes !== null && intakes.length">
      <table width=100%>
        <thead class="table-legend">
          <tr>
            <th></th>
            <th># / Port</th>
            <th>Gebruiker / Email / Tel</th>
            <th>Merk </th>
            <th>Adviseur / Beheerder</th>
            <th>Progress / Sinds</th>
            <th></th>
          </tr>
        </thead>
        <tr v-for="intake in intakes" :key="intake.id">
          <td style="padding:5px">
            <button
              class="secondary" @click="doAction('delete', intake)"
              style="float:right;padding:5px" title="Annuleren"
            >
              <awesomeIcon icon="trash"/>
            </button>
          </td>
          <td class="info">
            {{intake.id}}
            <br>
            [{{intake.port}}]
            <br>
            <template
              v-if="
                intake.admin
                && intake.admin.overwrite
              "
            >
              <awesomeIcon
                icon="question-circle"
                class="grey"
                :title="intake.admin.overwrite"
              />
            </template>
            <template
              v-if="
                intake.admin
                && view === 'Ingeleverd (plan)'
                && Number(intake.admin.showstoppersErrors) > 0
              "
            >
              <awesomeIcon
                icon="exclamation-circle"
                class="grey"
                :title="`Plan heeft nog ${intake.admin.showstoppersErrors} showstopper(s)`"
              />
            </template>
            <template
              v-if="
                view === 'Ingeleverd (plan)'
                && Number(intake.admin.blockersErrors) > 0
              "
            >
              <awesomeIcon
                icon="ban"
                class="grey"
                :title="`Plan heeft nog ${intake.admin.blockersErrors} blocker(s)`"
              />
            </template>
          </td>
          <td class="concat">
            <template v-if="
              intake.intake
              && intake.intake.persoonsData
              && intake.intake.persoonsData[0]
              && (
                intake.intake.persoonsData[0].voorletters
                || intake.intake.persoonsData[0].achternaam
              )
            ">
              <span class="help" :title="`${
                intake.intake.persoonsData[0].voorletters
              } ${
                intake.intake.persoonsData[0].tussenvoegsel
              } ${
                intake.intake.persoonsData[0].achternaam
              }`">
                {{intake.intake.persoonsData[0].voorletters}}
                {{intake.intake.persoonsData[0].tussenvoegsel}}
                {{intake.intake.persoonsData[0].achternaam}}
              </span>
            </template>
            <span v-else class="grey">-</span>
            <br>
            <span class="grey help" :title="intake.email">{{ intake.email }}</span>
            <br>
            <template v-if="
              intake.intake
              && intake.intake.persoonsData
              && intake.intake.persoonsData[0]
              && (intake.intake.persoonsData[0].telefoonnummer)
            ">
              {{
                intake.intake.persoonsData[0].telefoonnummer
                  .replace(/[^\d\+]/g, '').replace(/^\+/g, '00').replace(/[^\d]/g, '')
                  .replace(/^00/g, '+').replace(/^0/g, '+31')
              }}
            </template>
            <span v-else class="grey">-</span>
          </td>
          <td>
            <template v-if="intake.admin.beleggen && intake.admin.beleggen.brand">
              {{intake.admin.beleggen.brand}}
            </template>
            <span v-else class="grey">-</span>
            <br>
            <span
              class="concat"
              :title="`${intake.intake.goalData.type} ${intake.intake.goalData.box == 1
                ? 'box 1': ''}`"
              v-if="intake.intake && intake.intake.goalData && intake.intake.goalData.type"
            >
              {{intake.intake.goalData.type}}
              {{intake.intake.goalData.box == 1 ? ' box 1' : ''}}
            </span>
            <span v-else class="grey">-</span>
          </td>
          <td class="concat150">
            <span
              class="grey help" :title="find
              (users,
                { id: parseInt(intake.admin.beleggen.sales)}
              ).name" v-if="
              intake.admin.beleggen
              && find(users, { id: parseInt(intake.admin.beleggen.sales)})
            ">
              {{find(users, { id: parseInt(intake.admin.beleggen.sales)}).name}}
            </span>
            <span v-else class="grey">-</span>
            <br>
            <span
              class="grey help" :title="find
              (users,
                { id: parseInt(intake.admin.beleggen.manager)}
              ).name"
              v-if="
              intake.admin.beleggen
              && find(users, { id: parseInt(intake.admin.beleggen.manager)})
            ">
              {{find(users, { id: parseInt(intake.admin.beleggen.manager)}).name}}
            </span>
            <span v-else class="grey">-</span>
            <br>
            <template
              v-if="
              intake.intake
              && intake.intake.rekeningData
              && intake.intake.rekeningData.type
            ">
              {{intake.intake.rekeningData.type}}
            </template>
            <span v-else class="grey">-</span>
          </td>
          <td class="info">
            {{formatPrice(intake.progress, true)}}%
            <br>
            <span class="grey">
              <template
                v-if="intake.status_specific == 'Bezig'"
              >
                Aangemaakt op:<br />
                {{ localDate(intake.order_date) }}
                ({{dayCalculate(intake.order_date, true)}})
                <awesomeIcon
                  icon="user"
                  style="width:9px"
                  class="grey"
                  v-if="
                    find(users, { id: parseInt(intake.create_client) })
                    && intake.create_client !== intake.client
                  "
                  :title="'door ' + find(users, { id: parseInt(intake.create_client) }).email"
                />
              </template>
              <template v-if="intake.status_specific == 'Ingeleverd'">
                Ingeleverd op:<br />
                {{ localDate(intake.order_date) }}
                {{ intake.order_date ? "(" + dayCalculate(intake.order_date, true) + ")" : "-" }}
                <awesomeIcon
                  icon="user"
                  class="grey"
                  v-if="
                    find(users, { id: parseInt(intake.send_client) })
                    && intake.send_client !== intake.client
                  "
                  :title="'door ' + find(users, { id: parseInt(intake.send_client) }).email"
                />
              </template>
              <template v-if="intake.status_specific == 'Ingeleverd (plan)'">
                CDD akkoord op:
                  {{ localDate(intake.order_date) }}
                  {{ intake.order_date
                    ? "(" + dayCalculate(intake.order_date, true) + ")"
                    : "-"
                  }}
                  <awesomeIcon
                    icon="user"
                    class="grey"
                    :title="'door ' + intake.admin.cddStatus.user"
                  />
              </template>
              <template
                v-if="intake.status_specific == 'Ingeleverd (CDD)'"
              >
                CDD ingediend
                {{
                  intake.admin.oldRiskAnswer
                  ? `(${intake.admin.oldRiskAnswer})`
                  : '(Geen vorige risico)'
                }}
                op:<br />
                {{ localDate(intake.order_date) }}
                {{ intake.order_date
                  ? "(" + dayCalculate(intake.order_date, true) + ")"
                  : "-"
                }}
                <awesomeIcon
                  icon="user"
                  class="grey"
                  :title="'door ' + intake.admin.cddStatus.handedUser"
                />
              </template>
            </span>
          </td>
          <td>
            <button
              class="secondary"
              @click="doAction('view', intake)"
              style="float:right;padding:5px"
              title="Bekijken"
            >
              <awesomeIcon icon="search"/>
            </button>
          </td>
        </tr>
      </table>
      <pagerElement
        v-model="currentPage"
        :records="totalResults"
        :resultsPerPage="maxPerPage"
      />
    </div>
    <div v-else-if="intakes !== null" class="noresults">
      <span>Geen resultaten</span>
    </div>
    <div v-else class="loader"/>
  </div>
  <div v-else class="loader"></div>
</template>

<script>
import { find, findIndex, sumBy } from 'lodash-es';
import inputSuggest from './ui/inputSuggest';

export default {
  name: 'IntakesRedos',
  components: {
    inputSuggest,
  },
  data() {
    return {
      firstPageInit: true,
      filters: false,
      users: [],
      intakes: null,
      currentPage: 0,
      maxPerPage: 20,
      totalResults: null,
      currentIntake: '',
      brandDropdown: false,
      selectedBrands: ['Alle merken'],
      groupDropdown: false,
      advisorDropdown: false,
      view: 'Bezig',
      groups: [],
      intakeBrands: [
        'Alle merken',
        'Doelbeleggen',
        'OXBY',
        'VMVB',
        'BVS',
      ],
      order: 'orderDate',
      orders: [
        {
          label: 'Dagen (A)',
          value: 'orderDateAsc',
        },
        {
          label: 'Dagen (D)',
          value: 'orderDate',
        },
        {
          label: 'Voortgang',
          value: 'todo',
        },
        {
          label: 'Portefeuille',
          value: 'port',
        },
        {
          label: 'Startbedrag',
          value: 'inleg',
        },
      ],
      role: this.$store.state.role,
      search: '',
      idInput: '',
      portInput: '',
      investmentInput: '',
      progressInput: '',
      phoneInput: '',
      sinceInput: '',
      userInput: '',
      managerInput: '',
      currentAdvisor: null,
      advisors: [],
      priority: 'Beide',
      priorityTriple: [
        'Beide',
        'Ja',
        'Nee',
      ],
      creator: 'Beide',
      creatorTriple: [
        'Beide',
        'Gebruiker',
        'Admin',
      ],
      sender: 'Beide',
      senderTriple: [
        'Beide',
        'Gebruiker',
        'Admin',
      ],
    };
  },
  watch: {
    currentPage() {
      this.getIntakes();
    },
  },
  created() {
    if (this.readCookie('herintakesOrder')) {
      this.order = this.readCookie('herintakesOrder');
    }

    if (this.readCookie('herintakesFilterView')) {
      this.view = this.readCookie('herintakesFilterView');
    }

    if (this.readCookie('herintakesFilterId')) {
      this.idInput = this.readCookie('herintakesFilterId');
    }

    if (this.readCookie('herintakesFilterPort')) {
      this.portInput = this.readCookie('herintakesFilterPort');
    }

    if (this.readCookie('herintakesFilterBrands')) {
      this.selectedBrands = this.readCookie('herintakesFilterBrands').split(',');
    }

    if (this.readCookie('herintakesFilterValue')) {
      this.investmentInput = this.readCookie('herintakesFilterValue');
    }

    if (this.readCookie('herintakesFilterPriority')) {
      this.priority = this.readCookie('herintakesFilterPriority');
    }

    if (this.readCookie('herintakesFilterCreator')) {
      this.creator = this.readCookie('herintakesFilterCreator');
    }

    if (this.readCookie('herintakesFilterSender')) {
      this.sender = this.readCookie('herintakesFilterSender');
    }

    if (this.readCookie('herintakesFilterProgress')) {
      this.progressInput = this.readCookie('herintakesFilterProgress');
    }

    if (this.readCookie('herintakesFilterUser')) {
      this.userInput = this.readCookie('herintakesFilterUser');
    }

    if (this.readCookie('herintakesFilterPhone')) {
      this.phoneInput = this.readCookie('herintakesFilterPhone');
    }

    if (this.readCookie('herintakesFilterSince')) {
      this.sinceInput = this.readCookie('herintakesFilterSince');
    }

    if (this.readCookie('herintakesFilterAdvisor')) {
      this.currentAdvisor = this.readCookie('herintakesFilterAdvisor');
    }

    if (this.readCookie('herintakesFilterManager')) {
      this.managerInput = this.readCookie('herintakesFilterManager');
    }
  },
  mounted() {
    this.sdk.getUsersQuick((userResponse) => {
      this.users = userResponse.data;
      this.getIntakes(true);
      this.getAdvisors();
    });
  },
  methods: {
    find,
    toggleBrand(brand) {
      if (brand === 'Alle merken') {
        this.selectedBrands = [brand];
        return;
      }

      if (this.selectedBrands.includes('Alle merken')) {
        this.selectedBrands.splice(this.selectedBrands.indexOf('Alle merken'), 1);
      }

      if (this.selectedBrands.includes(brand)) {
        this.selectedBrands.splice(this.selectedBrands.indexOf(brand), 1);
      } else {
        this.selectedBrands.push(brand);
      }

      if (this.selectedBrands.length === 0) {
        this.selectedBrands = ['Alle merken'];
      }
    },
    creatorDrodownCB() {
      this.getIntakes(true);
    },
    generalDropdownCB() {
      this.getIntakes(true);
    },
    toggleFilters() {
      this.filters = !this.filters;

      if (this.filters) {
        if (this.search !== '') {
          this.search = '';
          this.getIntakes(true);
        }

        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.filters.style.overflow = 'visible';
          }, 150);
        });
      } else {
        this.$refs.filters.style.overflow = '';
      }
    },
    eraseCookie(name) {
      this.createCookie(name, '', -1);
    },
    getGroups() {
      this.groups = [
        {
          label: 'Bezig (0 / 0)',
          value: 'Bezig',
          totalRows: 0,
          totalRowsFiltered: 0,
        },
        {
          label: 'Ingeleverd (0 / 0)',
          value: 'Ingeleverd',
          totalRows: 0,
          totalRowsFiltered: 0,
        },
        {
          label: 'Ingeleverd (CDD) (0 / 0)',
          value: 'Ingeleverd (CDD)',
          totalRows: 0,
          totalRowsFiltered: 0,
        },
        {
          label: 'Ingeleverd (plan) (0 / 0)',
          value: 'Ingeleverd (plan)',
          totalRows: 0,
          totalRowsFiltered: 0,
        },
        {
          rightLabel: '0 her-intake(s)',
        },
      ];
      let filter = [];

      if (this.search) {
        filter.push(`search contains ${this.search}`);
      }

      if (this.idInput) {
        filter.push(`id eq ${this.idInput}`);
      }

      if (this.portInput) {
        filter.push(`port startswith ${this.portInput.trim()}`);
      }

      if (this.investmentInput) {
        filter.push(`capital eqgt ${this.investmentInput}`);
      }

      if (this.progressInput) {
        filter.push(`progress eqgt ${this.progressInput}`);
      }

      if (this.priority !== 'Beide') {
        filter.push(`priority eq ${this.priority === 'Ja'}`);
      }

      if (this.creator !== 'Beide') {
        filter.push(`creator eq ${this.creator === 'Admin'}`);
      }

      if (this.sender !== 'Beide') {
        filter.push(`sender eq ${this.sender === 'Admin'}`);
      }

      if (!this.selectedBrands.includes('Alle merken') && this.selectedBrands.length !== 0) {
        filter.push(`brand in ${this.selectedBrands.join(',')}`);
      }

      if (this.userInput) {
        filter.push(`client eq ${this.userInput}`);
      }

      if (this.phoneInput) {
        filter.push(`phone contains ${this.phoneInput.trim()}`);
      }

      if (this.sinceInput) {
        filter.push(`since eq ${this.sinceInput}`);
      }

      if (this.currentAdvisor) {
        filter.push(`advisor eq ${this.currentAdvisor}`);
      }

      if (this.managerInput) {
        filter.push(`manager eq ${this.managerInput}`);
      }

      filter = filter.join(';');
      this.sdk.getIntakeGroups((response) => {
        for (let i = 0; i < response.data.length; i += 1) {
          const index = findIndex(this.groups, { value: response.data[i].status });

          if (index !== -1) {
            this.groups[index].label = `${response.data[i].status} (0 / ${response.data[i].totalRows})`;
            this.groups[index].value = response.data[i].status;
            this.groups[index].totalRows = response.data[i].totalRows;
          }
        }

        this.sdk.getIntakeGroups((response2) => {
          for (let i = 0; i < response2.data.length; i += 1) {
            const index = findIndex(this.groups, { value: response2.data[i].status });
            this.groups[index].label = this.groups[index].label.replace(/\b0\b/, response2.data[i].totalRows);
            this.groups[index].totalRowsFiltered = response2.data[i].totalRows;
          }

          if (find(this.groups, { value: this.view }).totalRowsFiltered === 0) {
            for (let i = 0; i < this.groups.length; i += 1) {
              if (this.groups[i].totalRowsFiltered > 0) {
                this.view = this.groups[i].value;
                this.getIntakes();
                break;
              }
            }
          }
          this.groups[this.groups.length - 1].rightLabel = `${
            this.formatPrice(sumBy(this.groups, (group) => group.totalRowsFiltered), true)
          } / ${
            this.formatPrice(sumBy(this.groups, (group) => group.totalRows), true)
          } her-intake(s)`;
        }, true, filter);
      }, true);
    },
    clearInputs(origin) {
      if (origin !== 'generalSearch') {
        this.search = '';
        this.view = 'Bezig';
      }
      this.idInput = '';
      this.portInput = '';
      this.investmentInput = '';
      this.progressInput = '';
      this.phoneInput = '';
      this.sinceInput = '';
      this.priority = 'Beide';
      this.creator = 'Beide';
      this.sender = 'Beide';
      this.order = 'orderDate';
      this.selectedBrands = ['Alle merken'];
      this.currentAdvisor = null;
      this.intakes = null;
      this.$refs.managerInput.clear();
      this.$refs.userInput.clear();
      this.getIntakes(true);
    },
    dayCalculate(date, text = false, dateCompare = new Date()) {
      if (date) {
        const oneDay = 24 * 60 * 60 * 1000;
        // eslint-disable-next-line
        const days = Math.round(Math.abs(new Date(dateCompare).getTime() - new Date(date).getTime()) / oneDay);
        if (text) {
          return days + (days === 1 ? ' dag' : ' dagen');
        }
        return days;
      }
      return null;
    },
    localDate(date) {
      if (date) {
        return (new Date(date)).toLocaleDateString();
      }
      return null;
    },
    chooseGroup(group) {
      this.view = group;
      this.getIntakes(true);
    },
    chooseOrder(order) {
      this.order = order;
      this.getIntakes(true);
    },
    doAction(action, intake) {
      if (action === 'view') {
        window.open(`?intake=${intake.id}`);
      } else if (action === 'delete') {
        this.$store.state.confirm.toggle({
          text: 'Weet u zeker dat u deze intake wilt verwijderen?',
          confirmText: 'Verwijderen',
          cb: (confirmed) => {
            if (confirmed) {
              this.sdk.deleteIntake(intake.id, this.getIntakes);
            }
          },
        });
      }
    },
    getIntakes(newSearch) {
      this.intakes = null;
      let order = [];

      if (this.order === 'orderDateAsc') {
        order.push('date ASC');
      }

      if (this.order === 'orderDate') {
        order.push('date DESC');
      }

      if (this.order === 'todo') {
        order.push('progress DESC');
      }

      if (this.order === 'port') {
        order.push('port ASC');
      }

      if (this.order === 'inleg') {
        order.push('capital DESC');
      }

      this.createCookie('herintakesOrder', this.order);
      order = order.join(';');
      let filter = [];
      filter.push(`status_specific eq ${this.view}`);
      this.createCookie('herintakesFilterView', this.view);

      if (this.search) {
        filter.push(`search contains ${this.search}`);
        this.createCookie('herintakesFilterSearch', this.search);
      } else {
        this.eraseCookie('herintakesFilterSearch');
      }

      if (this.idInput) {
        filter.push(`id eq ${this.idInput}`);
        this.createCookie('herintakesFilterId', this.idInput);
      } else {
        this.eraseCookie('herintakesFilterId');
      }

      if (this.portInput) {
        filter.push(`port startswith ${this.portInput.trim()}`);
        this.createCookie('herintakesFilterPort', this.portInput.trim());
      } else {
        this.eraseCookie('herintakesFilterPort');
      }

      if (this.investmentInput) {
        filter.push(`capital eqgt ${this.investmentInput}`);
        this.createCookie('herintakesFilterValue', this.investmentInput);
      } else {
        this.eraseCookie('herintakesFilterValue');
      }

      if (this.progressInput) {
        filter.push(`progress eqgt ${this.progressInput}`);
        this.createCookie('herintakesFilterProgress', this.progressInput);
      } else {
        this.eraseCookie('herintakesFilterProgress');
      }

      if (this.priority !== 'Beide') {
        filter.push(`priority eq ${this.priority === 'Ja'}`);
        this.createCookie('herintakesFilterPriority', this.priority);
      } else {
        this.eraseCookie('herintakesFilterPriority');
      }

      if (this.creator !== 'Beide') {
        filter.push(`creator eq ${this.creator === 'Admin'}`);
        this.createCookie('herintakesFilterCreator', this.creator);
      } else {
        this.eraseCookie('herintakesFilterCreator');
      }

      if (this.sender !== 'Beide') {
        filter.push(`sender eq ${this.sender === 'Admin'}`);
        this.createCookie('herintakesFilterSender', this.sender);
      } else {
        this.eraseCookie('herintakesFilterSender');
      }

      if (!this.selectedBrands.includes('Alle merken') && this.selectedBrands.length !== 0) {
        filter.push(`brand in ${this.selectedBrands.join(',')}`);
        this.createCookie('herintakesFilterBrands', this.selectedBrands);
      } else {
        this.eraseCookie('herintakesFilterBrands');
      }

      if (this.userInput) {
        filter.push(`client eq ${this.userInput}`);
        this.createCookie('herintakesFilterUser', this.userInput);
      } else {
        this.eraseCookie('herintakesFilterUser');
      }

      if (this.phoneInput) {
        filter.push(`phone contains ${this.phoneInput.trim()}`);
        this.createCookie('herintakesFilterPhone', this.phoneInput.trim());
      } else {
        this.eraseCookie('herintakesFilterPhone');
      }

      if (this.sinceInput) {
        filter.push(`since eqgt ${this.sinceInput}`);
        this.createCookie('herintakesFilterSince', this.sinceInput);
      } else {
        this.eraseCookie('herintakesFilterSince');
      }

      if (this.currentAdvisor) {
        filter.push(`advisor eq ${this.currentAdvisor}`);
        this.createCookie('herintakesFilterAdvisor', this.currentAdvisor);
      } else {
        this.eraseCookie('herintakesFilterAdvisor');
      }

      if (this.managerInput) {
        filter.push(`manager eq ${this.managerInput}`);
        this.createCookie('herintakesFilterManager', this.managerInput);
      } else {
        this.eraseCookie('herintakesFilterManager');
      }

      filter = filter.join(';');
      if (newSearch) {
        this.currentPage = 0;
      }
      this.getGroups();
      this.sdk.getAdminIntakeRedos((response) => {
        this.firstPageInit = false;
        if (response.status === 200) {
          for (let i = 0; i < response.data.results.length; i += 1) {
            response.data.results[i].intake = JSON.parse(response.data.results[i].intake || '{}');
            response.data.results[i].admin = JSON.parse(response.data.results[i].admin || '{}');
            response.data.results[i].adviseur = 'Geen';
            if (response.data.results[i].admin.beleggen && find(
              this.users,
              { id: parseInt(response.data.results[i].admin.beleggen.sales, 10) },
            )) {
              response.data.results[i].adviseur = find(
                this.users,
                { id: parseInt(response.data.results[i].admin.beleggen.sales, 10) },
              ).name;
            }
            response.data.results[i].progress = (
              Number(response.data.results[i].intake.wrongFields)
              / Math.max(Number(response.data.results[i].intake.totalFields), 21)
            ) * 100;

            if (Number.isNaN(response.data.results[i].progress)) {
              response.data.results[i].progress = 0;
            }
            if (response.data.results[i].admin.beleggen) {
              response.data.results[i].brand = response.data.results[i].admin.beleggen.brand;
            }
            response.data.results[i].creatorAdmin = find(
              this.users,
              (o) => o.id === parseInt(response.data.results[i].create_client, 10) && o.role > 6,
            );
            response.data.results[i].handedAdmin = find(
              this.users,
              (o) => o.id === parseInt(response.data.results[i].send_client, 10) && o.role > 6,
            );
            response.data.results[i].voorrang = response.data.results[i].status === 'Ingeleverd'
              ? response.data.results[i].intake.goalData.riskChanged
                || response.data.results[i].intake.goalData.vtrChanged
              : false;
            response.data.results[i].todo = 100 - response.data.results[i].progress;
            response.data.results[i].inleg = 0;
          }
          this.intakes = response.data.results;
          this.totalResults = response.data.totalRows;
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      }, filter, order, this.currentPage, this.maxPerPage);
    },
    clearAdvisor() {
      this.advisorDropdown = false;
      this.currentAdvisor = null;
      this.getIntakes(true);
    },
    getAdvisors() {
      let filter = [];
      filter.push('role eqgt 7');
      filter = filter.join(';');
      this.sdk.getUserIds((response) => {
        if (response.status === 200) {
          this.advisors = [];

          for (let i = 0; i < response.data.results.length; i += 1) {
            this.advisors.push({
              label: response.data.results[i].name,
              value: response.data.results[i].id,
            });
          }
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      }, filter, 0, 100);
    },
  },
};
</script>
<style lang="scss" scoped>
.filters {
  width: 100%;
  height: 0;
  transition: height 0.15s;
  background-color: $color-highlight;
  border-radius: 0;
  overflow: hidden;
  &.active {
    height: 182px;
  }
  .filters-inner {
    width: 100%;
    height: 182px;
    padding: 0 2px 2px 0;
    box-sizing: border-box;
    .input {
      width: calc(100% / 5);
      height: 60px;
      padding: 4px 0 0 2px;
      box-sizing: border-box;
      display: inline-flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-direction: column;
      vertical-align: top;
      span {
        padding-left: 3px;
        font-weight: bold;
      }
      input {
        border-radius: 0;
        width: 100% !important;
        height: 36px;
        vertical-align: top;
        width: calc(calc(100% / 5) - 2px);
        &:focus {
          box-shadow: none;
        }
      }
      &.buttons {
        flex-direction: row;
        align-items: flex-end;
        float: right;
        button {
          width: calc(50% - 1px);
          height: 36px;
          border-radius: 0;
          background-color: rgba(0,0,0, 0.1);
          &:hover {
            background-color: rgba(0,0,0, 0.2);
          }
        }
      }
      .userIdInput {
        width: auto !important;
        display: inline-block;
        vertical-align: top;
      }
    }
    .triple-filter {
      width: calc(100% / 3);
      height: 60px;
      padding: 4px 0 0 2px;
      font-size: 13px;
      box-sizing: border-box;
      display: inline-flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-direction: column;
      .triple-name {
        padding-left: 3px;
        font-weight: bold;
      }
      .triple-filter-holder {
        overflow: hidden;
        height: 36px;
        width: 100%;
        cursor: pointer;
        div {
          width: calc(100% / 3);
          height: 100%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background-color: rgba(0, 0, 0, 0.1);
          &:hover,
          &.active {
            background-color: rgba(0, 0, 0, 0.2);
          }
        }
      }
    }
  }
}
.search-button {
  border-radius: 0;
}
.dropdown-button {
  float: left;
}
.menubar,
.dropdown-button {
  border-radius: 0 !important;
}
.concat {
  max-width: 175px;
  display: inline-block;
}
.dropdown-list {
  top: 36px;
}
.searchbar {
  margin-left: 2px;
  &:focus {
    box-shadow: none;
  }
}
.filter-dropdown {
  padding: 10px;
}
.noresults {
  width: 100%;
  height: auto;
  padding: 100px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    font-size: 20px;
  }
}
.multi-dropdown {
    width: 120px;
    margin: 0;
    display: inline-block;
    vertical-align: top;
    width: auto !important;
    .checkbox-green {
      color: #59b300;
    }
    button {
      border-radius: 0;
      margin-left: 2px !important;
    }
    .dropdown-button {
      margin-left: 3px;
      width: auto;
      padding: 0 10px;
    }
    .dropdown-list {
      width: auto;
      right: 0;
      top: 36px;
      li {
        display: flex;
        align-items: center;
        padding-left: 15px;
        position: relative;
        user-select: none;
        .dropdown-checkbox {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin-right: 10px;
          svg {
            font-size: 13px;
          }
        }
        span.logTypeId {
          position: absolute;
          top: 50%;
          right: 15px;
          transform: translateY(-50%);
        }
      }
    }
}
.info {
  svg {
    margin: 0px 2px;
    cursor: help;
  }
}
.help {
  cursor: help;
}
</style>
